export class Org
{
    constructor(
        public _id: string,
        public name: string) {  }

    public static default() { return new Org("", "Unknown Organization"); }
    public static empty() { return new Org("", ""); }
}
